import type { ModuleNavigation } from '../../layouts/ModuleSidebar';

// Sidebar entries should resolve to routes that stay within the jylaw shell.
// Cross-module links (e.g. /crm/*) belong on the top module bar, not here —
// otherwise clicking a sidebar entry swaps the whole shell, which is jarring.
export const jylawNavigation: ModuleNavigation = [
  {
    title: 'Overview',
    items: [
      { path: '/dashboard', label: 'Manager Dashboard' },
      { path: '/me', label: 'My Workspace' },
      { path: '/jylaw/dashboard', label: 'Admin View' },
      // spec-45 W2 — Expiry Dashboard (managing_partner, team_lead, lawyer)
      { path: '/dashboard/expiries', label: 'Expiry Dashboard' },
      // spec-47 W2 — Unified Ops Dashboard
      { path: '/dashboard/ops', label: 'Ops Dashboard' },
    ],
  },
  {
    title: 'My Work',
    items: [
      // spec-39 W4.6 — visible to lawyer/managing_partner/team_leader
      { path: '/tasks', label: 'My Tasks' },
      // spec-42 W6 — AI suggestions feed
      { path: '/suggestions', label: 'AI Suggestions' },
    ],
  },
  {
    title: 'Email Triage',
    items: [
      { path: '/email-inbox', label: 'Email Inbox' },
      { path: '/ocr-review', label: 'OCR Review' },
    ],
  },
  {
    title: 'Admin',
    items: [
      { path: '/admin/billing-entities', label: 'Billing Entities' },
      { path: '/admin/services-taxonomy', label: 'Services Taxonomy' },
      // spec-42.5 W3 — AI Detectors admin (managing_partner only)
      { path: '/admin/ai-detectors', label: 'AI Detectors' },
      // spec-49 W2 — Agreement Templates admin (managing_partner only)
      { path: '/admin/agreement-templates', label: 'Agreement Templates' },
      // spec-52 W3: Legacy Cleanup nav entry removed (tool retired; route redirects to agreement-templates)
    ],
  },
  {
    title: 'Integrations',
    items: [
      { path: '/admin/integrations/gmail', label: 'Gmail Connect' },
      { path: '/admin/integrations/calendar', label: 'Calendar Connect' },
    ],
  },
];
